<div #wrapper class="view-recipe-wrapper">
    <app-modal-header [text]="recipe?.recipeTitleBg" [bold]="true" (close)="bsModalRef.hide()"></app-modal-header>

    <div class="modal-body">

        <div class="form-group">
            <div class="form-check">
                <label class="form-check-label">
                    <input type="checkbox"
                           [(ngModel)]="showCookedWeight"
                           class="form-check-input">
                    Покажи в готово състояние
                    <i class="input-helper"></i>
                </label>
            </div>
        </div>

        <table class="products-table" *ngIf="recipe">
            <thead>
            <tr>
                <td>Продукт</td>
                <td>Грамаж</td>
                <td>Калории</td>
                <td>Протеин</td>
                <td>Въгл.</td>
                <td>Мазнини</td>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let product of sortedProducts(recipe.products)">
                <td>
                    {{ product.productTitleBg }}
                </td>

                <ng-container *ngIf="product.typeCalculation == 'WEIGHT'">
                    <td>
                        {{ showCookedWeight && product.cookedWeight > 0 ? roundNumber(product.cookedWeight) : roundNumber(product.weight) }}
                        g
                    </td>
                </ng-container>

                <ng-container *ngIf="product.typeCalculation == 'QTY'">
                    <td>
                        {{ roundNumber(product.qty) }} бр.
                    </td>
                </ng-container>

                <td>
                    {{ showCookedWeight && product.cookedCalories > 0 ? roundNumber(product.cookedCalories) : roundNumber(product.calories) }}
                    kcal
                </td>
                <td>
                    {{ showCookedWeight && product.cookedProtein > 0 ? roundNumber(product.cookedProtein) : roundNumber(product.protein) }}
                    g
                </td>
                <td>
                    {{ showCookedWeight && product.cookedCarbs > 0 ? roundNumber(product.cookedCarbs) : roundNumber(product.carbs) }}
                    g
                </td>
                <td>
                    {{ showCookedWeight && product.cookedFat > 0 ? roundNumber(product.cookedFat) : roundNumber(product.fat) }}
                    g
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</div>
